import { Component } from '@angular/core';
import { DynamicFieldConfig } from '../../../core/shared/dynamic-form/form-config.model';
import { TableColumn, TableAction } from '../../shared/models/table-models';
import { Table } from "../../shared/table/table";
import { DynamicFormComponent } from "../../../core/shared/dynamic-form/dynamic-form.component";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-terms',
  imports: [Table, DynamicFormComponent, TranslatePipe],
  templateUrl: './terms.html',
  styleUrl: './terms.css',
})
export class Terms {
 

  // ---------------------------
  // TABLE 1 — PROPOSED FACILITY
  // ---------------------------
  facilityColumns: TableColumn[] = [
    { key: 'facilityType', label: 'CREDIT_TERMS.FACILITY_TYPE' },
    { key: 'exposure', label: 'CREDIT_TERMS.EXPOSURE' },
    { key: 'description', label: 'COMMON.DESCRIPTION' },
    { key: 'disbursedBy', label: 'CREDIT_TERMS.DISBURSED_BY' }
  ];

  facilityData = [
    { facilityType: 'Term Finance', exposure: '200 MM', description: 'Direct Exposure', disbursedBy: 'Jul-2024' },
    { facilityType: 'Islamic Finance', exposure: '100 MM', description: 'Islamic Finance', disbursedBy: 'Jul-2024' },
    { facilityType: 'Credit Ensure', exposure: '100 MM', description: 'DFC Guarantee', disbursedBy: 'Jul-2024' }
  ];

  // ---------------------------
  // TABLE 2 — USAGE PLAN
  // ---------------------------
  usageColumns: TableColumn[] = [
    { key: 'sector', label: 'CREDIT_TERMS.SECTOR' },
    { key: 'exposure', label: 'CREDIT_TERMS.EXPOSURE' },
    { key: 'comments', label: 'CREDIT_TERMS.COMMENTS' }
  ];

  usageData = [
    { sector: 'Renewable Energy', exposure: '200 MM', comments: 'Comments will be place here' },
    { sector: 'Renewable Energy', exposure: '100 MM', comments: 'Comments will be place here' }
  ];

  // ---------------------------
  // TABLE ACTIONS
  // ---------------------------
  tableActions: TableAction[] = [
    {
      icon: 'images/edit-icon.png',
      
      onClick: (row) => this.editRow(row)
    },
    {
      icon: 'images/del-icon.png',
      onClick: (row) => this.deleteRow(row)
    }
  ];
markupColumns: TableColumn[] = [
  { key: 'facilityType', label: 'CREDIT_TERMS.FACILITY_TYPE' },
  { key: 'spread', label: 'CREDIT_TERMS.SPREAD' },
  { key: 'kibor', label: 'CREDIT_TERMS.PLUS_KIBOR' }
];

markupData = [
  { facilityType: 'Term Finance', spread: '3.5', kibor: 'Yes' },
  { facilityType: 'Islamic Finance', spread: '3.5', kibor: 'Yes' },
  { facilityType: 'Credit Ensure', spread: '0.5', kibor: 'Yes' }
];
feeColumns: TableColumn[] = [
  { key: 'name', label: 'COMMON.NAME' },
  { key: 'rate', label: 'CREDIT_TERMS.RATE' },
  { key: 'of', label: 'CREDIT_TERMS.OF' }
];

feeData = [
  { name: 'Upfront Fee', rate: '0.5', of: 'Disbursement Amount' },
  { name: 'Upfront Fee', rate: '0.5', of: 'Disbursement Amount' }
];
securityColumns: TableColumn[] = [
  { key: 'facilityType', label: 'CREDIT_TERMS.FACILITY_TYPE' },
  { key: 'pariPassu', label: 'CREDIT_TERMS.PARI_PASSU' }
];

securityData = [
  { facilityType: 'Term Finance', pariPassu: '80' },
  { facilityType: 'Islamic Finance', pariPassu: '80' },
  { facilityType: 'Credit Ensure', pariPassu: '0' }
];
covenantColumns: TableColumn[] = [
  { key: 'sr', label: 'CREDIT_TERMS.SR_HASH' },
  { key: 'description', label: 'COMMON.DESCRIPTION' },
  { key: 'condition', label: 'CREDIT_TERMS.CONDITION' }
];

covenantData = [
  {
    sr: 1,
    description: 'Maintain current ratio at least 1:1',
    condition: 'Before Trench 1'
  },
  {
    sr: 2,
    description: 'DSP to provide audited accounts for period ended June 2024',
    condition: 'Before Trench 1'
  }
];
onAddMarkup(){ console.log('Add Markup'); }
onAddFee(){ console.log('Add Fee'); }
onAddSecurity(){ console.log('Add Security'); }
onAddCovenant(){ console.log('Add Covenant'); }

  // ---------------------------
  // TENURE FORM
  // ---------------------------
  tenureFields: DynamicFieldConfig[] = [
    {
      key: 'firstWithdrawalDate',
      label: 'CREDIT_TERMS.FIRST_WITHDRAWAL_DATE',
      type: 'date',
      validations: { required: true }
    },
    {
      key: 'tranches',
      label: 'CREDIT_TERMS.PROPOSED_TRANCHES',
      type: 'number'
    },
    {
      key: 'frequency',
      label: 'CREDIT_TERMS.FREQUENCY',
      type: 'select',
      options$: [
        { label: 'CREDIT_TERMS.QUARTERLY', value: 'Quarterly' },
        { label: 'CREDIT_TERMS.MONTHLY', value: 'Monthly' }
      ]
    }
  ];

  // ---------------------------
  // REPAYMENT FORM
  // ---------------------------
  repaymentFields: DynamicFieldConfig[] = [
    { key: 'gracePeriod', label: 'CREDIT_TERMS.GRACE_PERIOD', type: 'number' },
    { key: 'installments', label: 'CREDIT_TERMS.NO_OF_INSTALLMENTS', type: 'number' },
    {
      key: 'frequency',
      label: 'CREDIT_TERMS.FREQUENCY',
      type: 'select',
      options$: [
        { label: 'CREDIT_TERMS.QUARTERLY', value: 'Quarterly' },
        { label: 'CREDIT_TERMS.MONTHLY', value: 'Monthly' }
      ]
    },
    {
      key: 'markupFrequency',
      label: 'CREDIT_TERMS.MARKUP_REPAYMENT_FREQUENCY',
      type: 'select',
      options$: [
        { label: 'CREDIT_TERMS.MONTHLY', value: 'Monthly' },
        { label: 'CREDIT_TERMS.QUARTERLY', value: 'Quarterly' }
      ]
    },
    {
      key: 'kiborReset',
      label: 'CREDIT_TERMS.KIBOR_RESET_PERIOD',
      type: 'select',
      options$: [
        { label: 'CREDIT_TERMS.MONTHLY', value: 'Monthly' },
        { label: 'CREDIT_TERMS.QUARTERLY', value: 'Quarterly' }
      ],
      gridClass: 'col-span-2'
    }
  ];

  // ---------------------------
  // ACTION HANDLERS
  // ---------------------------
  editRow(row:any){ console.log(row); }
  deleteRow(row:any){ console.log(row); }

  onAddFacility(){ console.log('Add Facility'); }
  onAddUsage(){ console.log('Add Usage'); }

}

